export default {
    cart_num:0,
    user_name:'',
    coupon_num:0,
    access_id:''
}